import styled from '@emotion/styled';
import { Button, Typography } from '@material-ui/core';
import { FC } from 'react';

import { useNewUx } from '../../services/newUx';

/**
 * NEW_UX announcement banner (reuses the former DadoAI banner surface). Shown only to
 * pending users (see useNewUx().showBanner): existing users who have not yet committed
 * to the new UX. It disappears permanently once the user turns the new experience on
 * (commitment); turning it off is a per-login temporary opt-out, so the banner stays.
 * New users never see it. Copy/design here is placeholder — refine in the design pass.
 */

const BannerContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '16px 48px',
  background: 'linear-gradient(90deg, #D2E8FD 0%, #D5F7E7 65%)',
  color: '#08121A',
  gap: 24,
  position: 'relative'
});

const BannerText = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: 2
});

const BannerActions = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  flexShrink: 0
});

export const DadoAIBanner: FC = () => {
  const { showBanner, enabled, setEnabled } = useNewUx();

  if (!showBanner) {
    return null;
  }

  return (
    <BannerContainer>
      <BannerText>
        <Typography
          component="h4"
          variant="h4"
          style={{ fontWeight: 700, color: '#08121A' }}
        >
          Introducing a new theme for Dado
        </Typography>
        <Typography variant="body2" style={{ color: '#08121A' }}>
          Not only a refreshed look but lots of extras. Keep it or switch back to
          classic.
        </Typography>
      </BannerText>
      <BannerActions>
        {enabled ? (
          <>
            <Button
              variant="text"
              onClick={() => setEnabled(false)}
              style={{ color: '#1D4ED8' }}
            >
              Switch to classic
            </Button>
            <Button
              variant="contained"
              onClick={() => setEnabled(true)}
              style={{ backgroundColor: '#1D4ED8', color: '#fff' }}
            >
              Keep new theme
            </Button>
          </>
        ) : (
          <Button
            variant="contained"
            onClick={() => setEnabled(true)}
            style={{ backgroundColor: '#1D4ED8', color: '#fff' }}
          >
            Keep new theme
          </Button>
        )}
      </BannerActions>
    </BannerContainer>
  );
};
